var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadLogo = function SvgUploadLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 2,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15030_5233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5581 12.3872C29.8022 12.1431 30.1979 12.1431 30.442 12.3872L34.0277 15.9729C34.2717 16.2169 34.2717 16.6127 34.0277 16.8567C33.7836 17.1008 33.3879 17.1008 33.1438 16.8567L30.625 14.338L30.625 23.5862C30.625 23.9314 30.3452 24.2112 30 24.2112C29.6548 24.2112 29.375 23.9314 29.375 23.5862L29.375 14.338L26.8563 16.8567C26.6122 17.1008 26.2165 17.1008 25.9724 16.8567C25.7283 16.6127 25.7283 16.2169 25.9724 15.9729L29.5581 12.3872ZM22.8286 22.9612C23.1738 22.9612 23.4536 23.241 23.4536 23.5862V25.3791C23.4536 26.024 23.9765 26.5469 24.6215 26.5469H35.3786C36.0236 26.5469 36.5464 26.024 36.5464 25.3791V23.5862C36.5464 23.241 36.8262 22.9612 37.1714 22.9612C37.5166 22.9612 37.7964 23.241 37.7964 23.5862V25.3791C37.7964 26.7144 36.7139 27.7969 35.3786 27.7969H24.6215C23.2861 27.7969 22.2036 26.7144 22.2036 25.3791V23.5862C22.2036 23.241 22.4834 22.9612 22.8286 22.9612Z",
    fill: "#2372B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15030_5233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(22 12)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "upload_logo.6e1e4dd44f10bed1d086c753290f0ea4.svg";